import React, { useEffect, useState } from "react";

import { Link, Outlet } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { FullscreenOutlined, FullscreenExitOutlined } from "@ant-design/icons";
import { Layout, Menu, theme, FloatButton } from "antd";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Quiz from "../../components/Common/Quiz/Quiz";
import "./index.css";

const { Sider, Content } = Layout;
const HeaderLayot = Layout.Header;

const Main = () => {
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(window.innerWidth < 1200);
  const [menuItems, setMenuItems] = useState([]);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const accessInformation = useSelector(
    (state) => state.authReducer.accessInformation
  );

  const getItem = (label, key, icon, children) => {
    return {
      key,
      icon,
      children,
      label,
    };
  };

  function openFullscreen() {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    } else if (document.documentElement.mozRequestFullScreen) {
      // Firefox
      document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullscreen) {
      // Chrome, Safari and Opera
      document.documentElement.webkitRequestFullscreen();
    } else if (document.documentElement.msRequestFullscreen) {
      // IE/Edge
      document.documentElement.msRequestFullscreen();
    }
  }

  function closeFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.mozCancelFullScreen) {
      // Firefox
      document.mozCancelFullScreen();
    } else if (document.webkitExitFullscreen) {
      // Chrome, Safari and Opera
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      // IE/Edge
      document.msExitFullscreen();
    }
  }

  // Create elements for Menu
  useEffect(() => {
    if (accessInformation && accessInformation.length !== 0) {
      const menuItemsVariable = [];
      let menuItemName;
      accessInformation.forEach((access, index) => {
        // Add dividers for different Access Groups
        if (menuItemName !== access.accessName && index !== 0) {
          menuItemsVariable.push({
            type: "divider",
            className: "main-sidebar-divider-color",
          });
        }
        menuItemName = access.accessName;

        access.urls.forEach((singleRoute) => {
          menuItemsVariable.push(
            getItem(
              <Link to={singleRoute.url}>{singleRoute.name}</Link>,
              singleRoute.url,
              <img
                src={`data:image/jpeg;base64,${singleRoute.icon}`}
                className="main-sidebar-menu-items-image"
                alt="menu-item-img"
              />
            )
          );
        });
      });
      setMenuItems(menuItemsVariable);
    }
  }, [accessInformation]);

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <Layout className="sidebar-layout">
        {screenWidth > 450 && (
          <FloatButton
            onClick={() => {
              if (document.fullscreenElement === null) {
                openFullscreen();
              } else {
                closeFullscreen();
              }
            }}
            icon={
              document.fullscreenElement === null ? (
                <FullscreenOutlined />
              ) : (
                <FullscreenExitOutlined />
              )
            }
          />
        )}
        <Sider
          collapsible
          collapsed={collapsed}
          collapsedWidth="0"
          width={window.innerWidth < 760 ? "85%" : "20%"}
          onCollapse={(value) => setCollapsed(value)}
        >
          <div className="sidebar-title">
            <h3 className="sidebar-heading">TouchSale Portal</h3>
          </div>
          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={location.pathname}
            items={menuItems}
            onClick={() => {
              if (window.innerWidth < 1200) {
                setCollapsed(true);
              }
            }}
          />
        </Sider>
        <Layout>
          <HeaderLayot
            style={{
              padding: 0,
              background: colorBgContainer,
            }}
          >
            <div>
              {(collapsed || window.innerWidth > 760) && (
                <Header collapsed={collapsed} />
              )}
            </div>
          </HeaderLayot>
          <Quiz />
          {(collapsed || window.innerWidth > 760) && (
            <Content
              style={{
                margin: "24px 16px",
                padding: 24,
                minHeight: 280,
                background: colorBgContainer,
                marginBottom: 0,
              }}
            >
              <Outlet />
            </Content>
          )}
          <Footer collapsed={collapsed} />
        </Layout>
      </Layout>
    </>
  );
};

export default Main;
